
export const apificate = (state, getters) => {
  let {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document
  } = state

  let {
    mercantileRegistry,
    irpf,
    greenPoint,
    specialRegime,
    ticketbaiRequired,
    siiRequired,
    headingBizkaia,
    verifactu,
    verifactuExemptionText,
    verifactuSelectedDate
  } = state.settings

  let {
    street,
    postalCode,
    town,
    city,
    country
  } = state.address

  return {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document,
    address: {
      street,
      postalCode,
      town,
      city,
      country
    },
    contactMedium: getters['contactMedium/apificate'],
    settings: {
      mercantileRegistry,
      irpf,
      greenPoint,
      specialRegime,
      ticketbaiRequired,
      siiRequired,
      headingBizkaia,
      verifactu,
      verifactuExemptionText,
      verifactuSelectedDate
    }
  }
}
